import React from 'react';
import { Check } from 'lucide-react';
export function PricingSection() {
  return <section id="oferta" className="py-5 sm:py-16 bg-[#0a1628] relative" data-id="element-118">
      <div className="max-w-3xl mx-auto px-3 sm:px-6" data-id="element-119">
        <div className="text-center mb-4 sm:mb-8" data-id="element-120">
          <h2 className="text-xl sm:text-4xl md:text-5xl font-black text-white uppercase tracking-tight" data-id="element-121">
            Oferta Especial
          </h2>
          <div className="h-0.5 sm:h-1 w-16 sm:w-20 bg-[#fbbf24] mx-auto mt-2 sm:mt-3 rounded-full" data-id="element-122"></div>
        </div>

        {/* MAIN OFFER BOX */}
        <div className="bg-white rounded-xl shadow-2xl overflow-hidden border-4 border-[#fbbf24] mb-8 sm:mb-12" data-id="element-123">
          <div className="bg-[#fbbf24] py-1.5 sm:py-3 text-center" data-id="element-124">
            <span className="text-[#0a1628] font-black text-xs sm:text-lg tracking-wider uppercase" data-id="element-125">
              ⭐ EL KIT MÁS VENDIDO ⭐
            </span>
          </div>

          <div className="p-3 sm:p-8 text-center" data-id="element-126">
            <h3 className="text-lg sm:text-3xl font-bold text-gray-900 mb-2 sm:mb-4" data-id="element-127">
              Kit Completo Economía Lista
            </h3>

            <div className="bg-gray-50 rounded-lg p-2.5 sm:p-5 mb-3 sm:mb-6 text-left max-w-sm mx-auto border border-gray-200" data-id="element-128">
              <p className="font-bold text-gray-700 mb-2 sm:mb-3 uppercase text-[10px] sm:text-xs tracking-wide text-center" data-id="element-129">
                Incluye todo esto:
              </p>
              <ul className="space-y-1.5 sm:space-y-2" data-id="element-130">
                {['Kit completo de contenidos (Módulos I a VI)', 'BONUS: Guía docente de primeros auxilios', 'BONUS: Guía maestra de planificación anual', 'BONUS: Actividades de GESTIÓN Y ORGANIZACIONES', 'Entrega digital en PDF mediante Drive', 'Garantía de 7 días'].map((item, i) => <li key={i} className="flex items-center text-gray-800 font-medium text-xs sm:text-sm" data-id="element-131">
                    <Check className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-green-500 mr-2 flex-shrink-0" strokeWidth={3} data-id="element-132" />
                    {item}
                  </li>)}
              </ul>
            </div>

            <div className="flex flex-col items-center justify-center mb-2 sm:mb-3" data-id="element-133">
              <span className="text-gray-400 text-sm sm:text-xl line-through font-medium mb-1" data-id="element-134">
                $19.99 USD
              </span>
              <div className="relative flex items-center justify-center" data-id="element-135">
                <div className="absolute inset-0 bg-[#16a34a]/20 blur-2xl rounded-full" data-id="element-136"></div>
                <span className="relative text-[#16a34a] text-4xl sm:text-6xl md:text-7xl font-black tracking-tight drop-shadow-[0_0_20px_rgba(21,128,61,0.5)] animate-pulse-subtle" data-id="element-137">
                  $14.99
                </span>
              </div>
              <span className="text-[#16a34a] text-sm sm:text-lg font-bold tracking-widest uppercase mt-1" data-id="element-138">
                USD
              </span>
            </div>

            <a href="https://checkout.docentesfelices.online/cart/55523146432585:1" className="block w-full bg-[#16a34a] hover:bg-green-700 text-white text-base sm:text-2xl font-black py-3.5 sm:py-4 px-4 rounded-lg shadow-[0_4px_0_rgb(21,128,61)] hover:shadow-[0_2px_0_rgb(21,128,61)] hover:translate-y-[2px] transition-all uppercase mb-2 sm:mb-3" data-id="element-139">
              COMPRAR AHORA →
            </a>

            <p className="text-base sm:text-xl text-gray-600 mb-3 sm:mb-4 font-bold" data-id="element-140">
              💳 Pagarás en la moneda de tu país.
            </p>

            <p className="text-gray-500 text-[10px] sm:text-xs" data-id="element-141">
              Luego del pago, recibirás el acceso automáticamente en tu correo
              electrónico.
            </p>
          </div>
        </div>

        {/* UPSELL BOX */}
        <div className="bg-[#1e293b] rounded-xl shadow-2xl overflow-hidden border border-gray-700 relative" data-id="element-142">
          {/* Top Content Banner */}
          <div className="w-full text-center bg-[#dc2626] py-2 sm:py-3" data-id="element-143">
            <span className="text-white text-sm sm:text-base md:text-lg font-black uppercase tracking-widest" data-id="element-144">
              Oferta Limitada
            </span>
          </div>

          <div className="p-3 sm:p-6 md:p-8" data-id="element-145">
            <div className="flex flex-col gap-3 sm:gap-6 items-center" data-id="element-146">
              <div className="w-full text-center" data-id="element-147">
                <span className="inline-block bg-blue-600 text-white text-base sm:text-lg md:text-xl font-bold px-4 py-1 rounded-full mb-3 uppercase tracking-wide shadow-md" data-id="element-148">
                  Pack Profesional
                </span>
                <h3 className="text-lg sm:text-2xl font-bold text-white mb-4" data-id="element-149">
                  KIT COMPLETO ECONOMÍA + MALETÍN DE 100 ACTIVIDADES DE ECONOMÍA
                </h3>

                {/* Upsell Image */}
                <div className="mb-4 sm:mb-6" data-id="element-150">
                  <a href="https://checkout.docentesfelices.online/cart/55523154427977:1" className="block hover:opacity-90 transition-opacity" data-id="element-151">
                    <img src="https://cdn.magicpatterns.com/uploads/6mTfaU9aNtauzPKRk8pK2f/20260118_1103_ImageGeneration_remix_01kf8pk8whfbgr0yjb02sr7qea.png" alt="Pack Profesional Maletín de 100 Actividades de Economía" className="w-full max-w-md mx-auto h-auto rounded-lg shadow-lg" data-id="element-152" />
                  </a>
                </div>

                <p className="text-gray-400 mb-3 sm:mb-4 text-xs sm:text-sm" data-id="element-153">
                  Eleva tus clases al siguiente nivel sin perder tiempo
                  preparando actividades desde cero.
                </p>

                <div className="flex flex-col items-center justify-center gap-1 sm:gap-2 mb-3 sm:mb-4" data-id="element-154">
                  <span className="text-gray-500 text-sm sm:text-lg line-through" data-id="element-155">
                    $29.99 USD
                  </span>
                  <div className="relative flex items-center justify-center" data-id="element-156">
                    <div className="absolute inset-0 bg-[#fbbf24]/20 blur-2xl rounded-full" data-id="element-157"></div>
                    <span className="relative text-[#fbbf24] text-4xl sm:text-6xl md:text-7xl font-black tracking-tight drop-shadow-[0_0_20px_rgba(251,191,36,0.5)] animate-pulse-subtle" data-id="element-158">
                      $18.99
                    </span>
                  </div>
                  <span className="text-[#fbbf24] text-sm sm:text-lg font-bold tracking-widest uppercase" data-id="element-159">
                    USD
                  </span>
                </div>
              </div>

              <div className="w-full flex flex-col md:flex-row gap-3 sm:gap-6 items-center" data-id="element-160">
                {/* Left - CTA */}
                <div className="flex-1 w-full text-center md:text-left" data-id="element-161">
                  <a href="https://checkout.docentesfelices.online/cart/55523154427977:1" className="block w-full bg-[#16a34a] hover:bg-green-700 text-white text-sm sm:text-lg font-bold py-2.5 sm:py-3 px-4 rounded-lg shadow-lg transition-colors text-center mb-2" data-id="element-162">
                    SÍ, QUIERO LA OFERTA →
                  </a>
                  <p className="text-base sm:text-xl text-gray-300 mt-2 font-bold" data-id="element-163">
                    💳 Pagarás en la moneda de tu país.
                  </p>
                </div>

                {/* Right Content - Features list */}
                <div className="flex-1 w-full" data-id="element-164">
                  <ul className="space-y-1 sm:space-y-1.5 text-[10px] sm:text-xs text-gray-300" data-id="element-165">
                    {['Actividades listas para trabajar en clase', 'Ideal para reforzar análisis económico y pensamiento crítico', 'Mayor variedad de propuestas didácticas', 'Ahorro de tiempo y mayor participación estudiantil'].map((item, i) => <li key={i} className="flex items-start" data-id="element-166">
                        <div className="min-w-[4px] h-[4px] rounded-full bg-[#fbbf24] mt-1 mr-1.5" data-id="element-167"></div>
                        {item}
                      </li>)}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}